import createDOMPurify from 'dompurify';

let DOMPurify;

if (__SERVER__) {
  const { JSDOM } = require('jsdom');
  const { window } = new JSDOM('');

  DOMPurify = createDOMPurify(window);
} else {
  DOMPurify = createDOMPurify;
}

export default DOMPurify.sanitize;
